export const getChartColors = () => {
  return {
    backgroundColor: [
      "#00973b", // Yes
      "#00973b", // Yes But
      "red", // No
      "#ffde15", // Discussion Required
      "#00973b", // Acknowledged
      "#0079c7", // Abstention
      "#ccc", // Not Answer
    ],
    hoverBackgroundColor: [
      "#007a30", // Hover for Yes
      "#007a30", // Hover for Yes But
      "darkred", // Hover for No
      "#ffcc00", // Hover for Discussion Required
      "#007a30", // Hover for Acknowledged
      "#0056b3", // Hover for Abstention
      "#aaa", // Hover for Not Answer
    ],
  };
};
